window.addEventListener('load', event => {
    let formPanels = document.querySelectorAll('.form-panel');
    for (let formPanel of formPanels) {
        let formContainer = formPanel.querySelector('.form-container');
        let formContainerScrollAnchor = formPanel.querySelector('.form-scroll-anchor');
        let formHiddenHeight = 0;
        let firstRun = true;
        let formButtons = formPanel.querySelectorAll('.form-selector-button');
        let resetPanelDebounce =  _debounce(resetPanel, 50, {leading: true, trailing: true});

        let formInputContactType = formPanel.querySelector('input[name="preferredContactMethod"]');
        let panelWidth = formContainer.offsetWidth;
        let formHeadingOptions = formPanel.querySelectorAll('div[data-contactmethod]');

        let emailInput = formPanel.querySelector('input[name="email"]');
        let phoneInput = formPanel.querySelector('input[name="phone"]');

        let isFormModal = !!formPanel.classList.contains('contact-form-modal') || !!formPanel.classList.contains('investor-form-modal');
        let formModalBack = formPanel.querySelector('.form-modal-back');
        let formContainerHeightStartA = isFormModal ? '!h-[30rem]' : '!h-0' ;
        let formContainerHeightStartB = isFormModal ? 'sm:!h-60' : '!h-0';
        let modalHeadingContainer = formPanel.querySelector('.modal-heading-container');

        for (let formHeading of formHeadingOptions) {
            formHeading.closest('.freeform-row').classList.add('!hidden');
        }

        if (isFormModal && formModalBack) {
            formModalBack.addEventListener('click', event => {
                let submissionSuccess = formPanel.querySelector('.submission-success');
                if (!submissionSuccess) {
                    resetPanel(true);
                }
            })
        }

        for (let button of formButtons) {
            let formType = button.dataset.formtype;

            button.addEventListener('click', event => {
                if (formType === 'Facebook Messenger') {
                    resetPanel(true);
                    let hasReallyLoaded = !!document.querySelector('.fb_dialog_content iframe');
                    if ((hasReallyLoaded === true) && (window.fbChatLoaded ?? false)) {
                        FB.CustomerChat.show(true);
                    } else {
                        let fbUrl = button.dataset.url;
                        if (fbUrl !== '') {
                            window.open(fbUrl, '_blank')?.focus();
                        }
                    }
                    return;
                }
                panelWidth = formContainer.offsetWidth;
                let alreadyOpen = formContainer.dataset.formtype === formType;

                if (formInputContactType) {
                    formInputContactType.value = formType;
                }

                for (let formHeading of formHeadingOptions) {
                    if (formHeading.dataset.contactmethod === formInputContactType.value) {
                        formHeading.closest('.freeform-row').classList.remove('!hidden');
                    } else {
                        formHeading.closest('.freeform-row').classList.add('!hidden');
                    }
                }

                if (formInputContactType.value === 'Call' || formInputContactType.value === 'SMS') {
                    phoneInput.closest('div').querySelector('label').classList.add('required-input-form-field');
                    phoneInput.setAttribute('required', 'true');
                    emailInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                    emailInput.removeAttribute('required');
                } else {
                    emailInput.closest('div').querySelector('label').classList.add('required-input-form-field');
                    emailInput.setAttribute('required', 'true');
                    phoneInput.closest('div').querySelector('label').classList.remove('required-input-form-field');
                    phoneInput.removeAttribute('required');
                }

                if (!alreadyOpen) {
                    formContainer.dataset.formtype = formType;

                    if (window.matchMedia('(max-width: 1024px)').matches) {
                        formContainerScrollAnchor.scrollIntoView({
                            behavior: 'smooth',
                            alignToTop: true
                        })
                    }

                    if (isFormModal) {
                        let iconGridContainer = formPanel.querySelector('.form-icon-grid');
                        iconGridContainer.classList.add('pointer-events-none','select-none', 'opacity-0', 'blur-lg', '-translate-x-full');
                        formContainer.classList.remove('pointer-events-none','select-none', 'opacity-0', 'blur-lg','translate-x-full');
                        formModalBack.classList.remove('opacity-0','pointer-events-none','select-none')
                        if (modalHeadingContainer) {
                            modalHeadingContainer.classList.add('pointer-events-none','select-none', 'opacity-0', 'blur-lg', '-translate-x-full', 'pb-0', '!max-h-0');
                        }
                    }

                    if (formContainer.dataset.formtype === 'none') {
                        formContainer.classList.remove('transition-all');
                    }

                    formContainer.classList.remove(formContainerHeightStartA, formContainerHeightStartB);
                    formContainer.removeAttribute('style');
                    formHiddenHeight = formContainer.offsetHeight;

                    if (firstRun) {
                        formContainer.classList.add(formContainerHeightStartA, formContainerHeightStartB);
                        firstRun = false;
                    }

                    for (let otherButtons of formButtons) {
                        otherButtons.classList.remove('!border-green-brand');
                    }
                    button.classList.add('!border-green-brand');

                    setTimeout(() => {
                        formContainer.classList.add('transition-all');
                        formContainer.classList.remove(formContainerHeightStartA, formContainerHeightStartB,'opacity-0','blur-lg');
                        formContainer.setAttribute('style',`height:${formHiddenHeight}px`);
                        window.addEventListener('resize', resetPanelDebounce, {passive: true})
                    }, 50);
                }
            });
        }

        function resetPanel(onCall) {
            if ((formContainer.offsetWidth !== panelWidth) || (onCall === true)) {
                firstRun = true;
                formContainer.dataset.formtype = 'none';
                formContainer.classList.add(formContainerHeightStartA, formContainerHeightStartB,'opacity-0','blur-lg');
                window.removeEventListener('resize', resetPanelDebounce);
                for (let buttons of formButtons) {
                    buttons.classList.remove('!border-green-brand');
                }
                resetModal();
            }
        }

        function resetModal() {
            if (isFormModal) {
                let iconGridContainer = formPanel.querySelector('.form-icon-grid');
                iconGridContainer.classList.remove('pointer-events-none','select-none', 'opacity-0', 'blur-lg', '-translate-x-full');
                formContainer.classList.add('pointer-events-none','select-none', 'opacity-0', 'blur-lg','translate-x-full');
                formModalBack.classList.add('opacity-0','pointer-events-none','select-none');
                if (modalHeadingContainer) {
                    modalHeadingContainer.classList.remove('pointer-events-none','select-none', 'opacity-0', 'blur-lg', '-translate-x-full', 'pb-0', '!max-h-0');
                }
            }
        }
    }
});